// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
// import { VDataTable } from "vuetify/labs/VDataTable"; pour mise à jour vuetify 3.4.6
// import { VDatePicker } from "vuetify/lib/components/VDatePicker";
require("@/assets/main.scss");

const theme = {
  dark: false,
  colors: {
    background: "#FFFFFF",
    surface: "#FFFFFF",
    primary: "#087B7A",
    "primary-darken-1": "#3700B3",
    secondary: "#0097AC",
    "secondary-darken-1": "#018786",
    error: "#e30613",
    info: "#2196F3",
    success: "#087B7A",
    warning: "#f5B100",
  },
};

export default createVuetify({
  components: {},
  theme: {
    defaultTheme: "theme",
    themes: {
      theme,
    },
  },
  defaults: {
    VTextField: {
      density: "compact",
      variant: "underlined",
    },
    VAutocomplete: {
      density: "compact",
      variant: "underlined",
    },
    VSelect: {
      density: "compact",
      variant: "underlined",
    },
  },
});
